import { createRouter, createWebHashHistory } from "vue-router";

import hubRoutes from "./routes/hub-routes";
import digibordRoutes from "./routes/digibord-routes";

const routes = [...hubRoutes, ...digibordRoutes];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
